import { h } from "omi";

import { IconProps } from "@/wc/components";

export function ShareIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" width={width} height={height}>
      <path
        d="M17.3261 10.7376c.2035-.1744.3052-.2615.3425-.3653.0327-.0911.0327-.1907 0-.2817-.0373-.10377-.139-.19095-.3425-.36533l-7.0589-6.05052c-.3502-.30016-.52529-.45024-.67353-.45392-.12884-.00319-.2519.05341-.33332.15331-.09368.11494-.09368.34556-.09368.80678V7.7603c-1.7789.31122-3.40701 1.21261-4.61691 2.566C3.23069 11.8019 2.50103 13.7114 2.5 15.6906v.51a9.500852 9.500852 0 0 1 3.20063-2.4976c1.08828-.522 2.26472-.8313 3.46604-.9128v3.4918c0 .4612 0 .6918.09368.8068.08142.0999.20448.1565.33332.1533.14824-.0037.32333-.1538.67353-.454l7.0589-6.0505Z"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
